import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useOrganicRegistrationForm } from '..';
import { useDirectAccessAnalytics } from '../../../../../hooks/useAnalytics';

const OneTimeVerificationCodeFlow = () => {
  const { formValues, setFormValues, otvcValues, setOtvcValues } =
    useOrganicRegistrationForm();
  const { track } = useDirectAccessAnalytics();

  useEffect(() => {
    track('Registration Started', {
      event_type: 'Link Accessed',
      location: 'Feature Card',
      registration_type: 'OTVC',
      login_method: 'SSO',
    });
  }, []);

  return (
    <Outlet
      context={{ formValues, setFormValues, otvcValues, setOtvcValues }}
    />
  );
};

export default OneTimeVerificationCodeFlow;
